import { DataHelper } from "src/services/dataHelper";

export const trackVisitor = () => {
    try {
        let visitorId = localStorage.getItem("visitorId");

        if (!visitorId) {
            visitorId = crypto.randomUUID();
            localStorage.setItem("visitorId", visitorId);
        }

        const payload = {
            PageUrl: "https://www.alshashahfashion.ae/",
            VisitorId: visitorId,
            Country: "UAE"
        };

        const dataObj = {
            dataObj: JSON.stringify(payload)
        };

        // ✅ SINGLE API CALL
        new DataHelper().save("Visitor", dataObj, {
            headers: {
                "X-Visitor-Id": visitorId
            }
        });

    } catch (error) {
        console.error("Visitor tracking failed", error);
    }
};
